var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-page',{attrs:{"title":_vm.pageTitle},scopedSlots:_vm._u([{key:"header-actions",fn:function(){return [_c('x-back-button',{attrs:{"disabled":_vm.isLoading,"display-warning":false}})]},proxy:true}])},[_vm._v(" "),(_vm.resource)?_c('metric-form',{attrs:{"id":"metric-form","disabled":true,"initialFields":_vm.resource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }